import { render } from "./NotFound.vue?vue&type=template&id=c522bb42"
const script = {}

import exportComponent from "/var/www/html/chatbot_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__